(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.setupHomepageHoverPersistence();
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.teardownHomepageHoverPersistence();
    }

    setupHomepageHoverPersistence() {
      if (!this.classList.contains('header-wrapper--index-transparent')) return;

      this.setHeaderHoverActive = () => this.header.classList.add('header-hover-active');
      this.clearHeaderHoverActive = () => this.header.classList.remove('header-hover-active');
      this.hoverTargets = this.querySelectorAll(
        '.header a, .header summary, .header__icon, .header__menu-item, .header__heading-link, .header__heading-logo'
      );

      this.hoverTargets.forEach((element) => {
        element.addEventListener('mouseenter', this.setHeaderHoverActive);
      });

      this.header.addEventListener('mouseleave', this.clearHeaderHoverActive);
    }

    teardownHomepageHoverPersistence() {
      if (!this.hoverTargets || !this.setHeaderHoverActive || !this.clearHeaderHoverActive) return;

      this.hoverTargets.forEach((element) => {
        element.removeEventListener('mouseenter', this.setHeaderHoverActive);
      });

      this.header.removeEventListener('mouseleave', this.clearHeaderHoverActive);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function setupCollectionsHoverMenu() {
    const desktopHoverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
    const collectionsSummary = document.querySelector('#HeaderMenu-collections');
    const collectionsDetails = collectionsSummary ? collectionsSummary.closest('details') : null;

    if (!collectionsSummary || !collectionsDetails || collectionsDetails.dataset.hoverMenuBound === 'true') return;

    const openCollectionsMenu = () => {
      if (!desktopHoverMediaQuery.matches) return;
      collectionsDetails.setAttribute('open', '');
      collectionsSummary.setAttribute('aria-expanded', 'true');
    };

    const closeCollectionsMenu = () => {
      collectionsDetails.removeAttribute('open');
      collectionsSummary.setAttribute('aria-expanded', 'false');
    };

    collectionsDetails.addEventListener('mouseenter', openCollectionsMenu);
    collectionsDetails.addEventListener('mouseleave', closeCollectionsMenu);

    collectionsSummary.addEventListener('click', (event) => {
      if (!desktopHoverMediaQuery.matches) return;
      event.preventDefault();
      if (collectionsDetails.hasAttribute('open')) {
        closeCollectionsMenu();
      } else {
        openCollectionsMenu();
      }
    });

    desktopHoverMediaQuery.addEventListener('change', (event) => {
      if (!event.matches) closeCollectionsMenu();
    });

    collectionsDetails.dataset.hoverMenuBound = 'true';
  }

  setupCollectionsHoverMenu();
  document.addEventListener('shopify:section:load', setupCollectionsHoverMenu);

  } catch(e) { console.error(e); }
})();
})();
